import "./sass/index.css";
import '@aws-amplify/ui-react/styles.css';
import { Authenticator } from '@aws-amplify/ui-react'
import { initFirebase } from "@material-dev/insights-portal-ui-components/lib"; 
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { APP_NAME } from "const/config";
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from "aws-amplify/utils";
import { Amplify } from "aws-amplify";

import App from "./app/App";
import store from "./app/store";
import * as serviceWorker from "./serviceWorker";
import { AmplifyConfig} from './amplify-config';

Amplify.configure(AmplifyConfig);
cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage());

(function startFirebase() {
  if (process.env.REACT_APP_FIREBASE_API_KEY) {
    initFirebase(APP_NAME);
  }
})();

const container = document.getElementById("root");

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
  <Authenticator.Provider>
    <Provider store={store}>
      <App />
    </Provider>
  </Authenticator.Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
